import { LOCALES } from 'i18n/locales';

export const footerIntl = {
    [LOCALES.ENGLISH]: {
        'footer.support': 'Support Links',
        'footer.link.privacy': 'Privacy',
        'footer.link.cookies': 'Cookies',
        'footer.link.contact': 'Contact',
        'footer.license.description.1': 'All content is available under the ',
        'footer.license.description.2': 'Open Government Licence v3.0',
        'footer.license.description.3': ', except where otherwise stated',
        'footer.copyright': '© Crown copyright'
    },
    [LOCALES.WELSH]: {
        'footer.support': 'Dolenni Cymorth',
        'footer.link.privacy': 'Preifatrwydd.',
        'footer.link.cookies': 'Cwcis',
        'footer.link.contact': 'Cysylltu',
        'footer.license.description.1': 'Mae\'r holl gynnwys ar gael o dan y ',
        'footer.license.description.2': 'Drwydded Llywodraeth Agored v3.0',
        'footer.license.description.3': ', ac eithrio lle nodir yn wahanol',
        'footer.copyright': '© Hawlfraint y goron'
    }
};
